import React, {FC, useState} from 'react'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import ContainerWrapper from '../../componentes/Container'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {renderPanelContent} from '../components'
import {FormProvider, useForm} from 'react-hook-form'
import ActionsContent from '../../componentes/Actions'
import {laundryConfigHourSchema} from '../../../schema/laundryConfig'
import {yupResolver} from '@hookform/resolvers/yup'
import {LaundryConfigHoursDto} from '../../../model'
import {
  createLaundryConfigHours,
  deleteLaundryConfigHours,
  updateLaundryConfigHours,
} from '../../../services'
import {TabLavanderiaModel} from '../../../../../models'
import {
  ERROR_MESSAGE_SYSTEM,
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
} from '../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../util/functions'
import {funcDelete} from '../../../util/function'

const LaundryConfigHoursPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [loading, setLoading] = useState(false)

  const methods = useForm<LaundryConfigHoursDto>({
    resolver: yupResolver(laundryConfigHourSchema),
  })

  const {reset} = methods

  const onSubmit = async (data: any) => {
    try {
      setLoading(true)
      const isCreating = !currentTabItem.idToEdit
      const response = isCreating
        ? await createLaundryConfigHours(data)
        : await updateLaundryConfigHours({...data, Id: currentTabItem.idToEdit})
      if (!response.data.error) {
        reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        const obj: TabLavanderiaModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-configuration-hours',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar(messageResponse)
      } else {
        ShowSnackBar(response.data.messageSystem ?? ERROR_MESSAGE_SYSTEM, 'error')
      }
    } catch (error) {
      console.error(ERROR_MESSAGE_SYSTEM, error)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    } finally {
      setLoading(false)
    }
    setLoading(false)
  }

  const handleDelete = async () => {
    await funcDelete(
      deleteLaundryConfigHours,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-configuration-hours'
          textComponentGo='form-configuration-hours'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-lavanderia-header-${currentTabItem.id}`}
              id={`panel-lavanderia-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-lavanderia-detail-${currentTabItem.id}`}
                    id={`panel-lavanderia-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default LaundryConfigHoursPageWrapper
